module.exports = __webpack_public_path__ + "36ec64746de40b75524a216fa27b322a.pdf";